export default {
  views: {
    privacy: {
      lastUpdated: '최종 업데이트: 2026년 9월 10일',
      companyName: '링크티비티 주식회사(Linktivity Inc.)',
      title: '개인정보 처리방침',
      personalInfoProtectionPolicy: '개인정보 보호방침',
      personalInfoProtectionDescription:
        '당사는 당사가 운영하는 예약 사이트 LINKTIVITY 등에서 고객으로부터 개인정보를 취득하고 있습니다. 당사는 고객이 안심하고 편리하게 예약할 수 있도록 하기 위하여 고객의 개인정보를 보호하는 것이 매우 중요하다고 생각하며, 아래에 기재된 사항을 준수하여 개인정보를 취급하고 있습니다.',
      customerDataManager: '고객의 개인데이터 관리자',
      companyAddress:
        '우편번호 100-0011 도쿄도 지요다구 우치사이와이초 2-1-6 히비야 파크 프론트 19F',
      acquisition: '취득 시',
      acquisitionDescription:
        '당사는 법령에 의하여 필요한 경우에는 고객으로부터 동의를 받은 후, 당사의 이용 목적 달성에 필요한 최소한의 개인정보를 취득합니다.',
      usage: '이용 시',
      usageDescription:
        '당사는 당사가 정한 이용 목적의 달성을 위해서만 고객으로부터 취득한 개인정보를 이용합니다.',
      storage: '보관·보존 시',
      storageDescription:
        '당사는 고객으로부터 취득한 개인정보가 외부로 누출되지 않도록 시스템 보안에 유의하여 개인정보의 보관·보존 등을 실시하고 있습니다.',
      destruction: '폐기·삭제 시',
      destructionDescription:
        '당사는 이용할 필요가 없어진 개인데이터(개인정보의 보호에 관한 법률에서 정하는 개인데이터를 의미합니다. 이하 동일합니다.)는 필요가 없어진 시점에 지체 없이 폐기합니다.',
      customerInquiry: '고객 문의 등에 대한 대응',
      customerInquiryDescription:
        '당사는 고객으로부터의 보유 개인데이터(개인정보의 보호에 관한 법률에서 정하는 보유 개인데이터를 의미합니다. 이하 동일합니다.)의 이용 목적 통지 요구, 공개 청구, 정정·추가·삭제 청구, 이용 정지·소거 청구 및 제3자 제공의 정지 청구에 대하여 법령에 따라 대응합니다.',
      safetyMeasures: '안전관리조치 등',
      safetyMeasuresDescription:
        '당사는 LINKTIVITY 서비스에 관계된 모든 스태프가 개인정보의 중요성을 이해할 수 있도록 교육을 실시하는 것 외에, 개인정보의 안전관리를 위하여 필요하고 적절한 조치를 취하고 있습니다.',
      tableOfContents: '목차',
      policy1: {
        title: '당사가 취득하는 개인정보와 이용 목적에 대하여',
        description:
          '당사는 아래에 기재된 이용 목적으로 고객의 주소, 성명, 생년월일, 연락처, 이메일 주소 또는 여권번호 등의 개인정보를 취득하고 이용합니다. 또한 당사는 고객의 동의 없이 배려가 필요한 개인정보를 취득하지 않습니다. 그리고 고객의 개인정보를 취득할 때 개인정보의 이용 목적이 공표되어 있지 않은 경우에는, 해당 취득의 대상이 된 개인정보의 이용 목적을 고객에게 통지하거나 공표합니다. 또한 당사는 보호자의 동의 없이 13세 이하의 아동으로부터 개인정보를 취득하지 않습니다. 13세 이하 아동의 개인정보를 제공받는 경우, 보호자의 동의를 받은 것으로 취급하되, 동의가 없는 것이 명백해진 경우에는 보호자에 대한 연락 및 이에 부수하는 목적 이외의 목적으로 해당 개인정보를 이용하지 않습니다.',
        serviceUsage: {
          title: 'LINKTIVITY 서비스 이용(회원 등록 등)을 위하여',
          description:
            'LINKTIVITY 서비스 이용을 위하여 고객의 개인정보를 당사 내부에서 공유합니다.',
          legalBasis:
            '고객이 요구하는 서비스나 기능을 제공하기 위하여 필요합니다.'
        },
        ticketPurchase: {
          title: '티켓 구매 신청을 위하여',
          infoItems:
            '당사는 고객의 상품 제공자로부터의 티켓 구매 신청 등에 있어 고객의 성명, 결제 정보, 여권번호 외에 건강 상태나 병력 등과 같은 고객의 건강 상태에 관한 정보 등을 취득합니다.',
          purpose:
            '당사는 고객의 상품 제공자로부터의 티켓 구매 자격 확인이나 티켓 대금 등의 결제를 위하여 고객의 개인정보를 취득하고 이용합니다. 또한 이러한 목적을 위하여 상품 제공자, 교통기관, 대금 결제 사업자 등(해외 사업자 등을 포함합니다.)에게 고객의 개인정보를 제공합니다.',
          legalBasis:
            '고객이 요구하는 서비스나 기능을 제공하기 위하여 필요합니다.'
        },
        newsletter: {
          title:
            '뉴스레터(이메일 매거진 등)의 발송 등 고객에 대한 안내 발송을 위하여',
          legalBasis: '고객의 동의에 기초하여 수집합니다.'
        },
        advertising: {
          title: '소셜미디어 및 광고 배포 플랫폼을 통한 광고를 위하여',
          legalBasis: '고객의 동의에 기초하여 수집합니다.'
        },
        survey: {
          title: '설문조사 작성 요청을 위하여',
          legalBasis:
            '당사의 예약 사이트, 상품 및 서비스 등의 개선을 위하여 고객의 동의에 기초하여 수집합니다.'
        },
        analysis: {
          title: '고객 정보의 분석 및 관리를 위하여',
          legalBasis:
            '당사의 예약 사이트, 상품 및 서비스 등을 개선함으로써 고객의 정당한 이익을 추구·보호하기 위하여 필요합니다.'
        },
        fraudDetection: {
          title: '신용카드 등의 부정 이용 탐지 및 방지를 위하여',
          description1:
            '당사는 티켓 예약 서비스 및 회원 등록 서비스에서의 부정 구매, 부정 전매, 사칭, 부정 결제, 차지백 그 밖의 부정행위의 탐지 및 방지, 그리고 서비스의 안전성 향상을 목적으로 다음의 정보를 취득하여 이용하는 경우가 있습니다. 제공 대상에는 Forter Inc. 및 당사가 별도로 공표하는 부정 이용 방지 서비스 제공 사업자가 포함됩니다.',
          description2:
            '당사가 제공하는 정보에는 성명, 생년월일, 이메일 주소, 전화번호, 주소, 예약 정보, 구매 이력, 결제 관련 정보, IP 주소, 쿠키 정보, 브라우저 정보, 단말기 정보, 접속 로그 및 그 밖에 부정 이용 방지를 위하여 필요한 정보가 포함되는 경우가 있습니다.',
          description3:
            '제공 대상은 이러한 정보를 분석하여 거래에 관한 리스크 평가, 부정 이용 판정, 본인 확인 지원 및 그 밖의 부정 이용 방지 서비스를 제공합니다.',
          description4:
            '당사는 해당 사업자로부터 제공되는 분석 결과 및 판정 결과를 예약 접수, 회원 등록, 본인 확인, 결제 처리, 부정 이용 방지 및 서비스 운영을 위하여 이용하며, 거래의 승인, 보류 또는 추가 확인의 필요 여부를 판단하는 경우가 있습니다.',
          legalBasis:
            '부정 이용 방지 및 신용카드 등의 부정 결제 방지를 통하여 당사 및 고객의 정당한 이익을 추구하기 위하여 필요합니다.'
        }
      },
      policy2: {
        title: '개인데이터의 제3자 제공에 대하여',
        description:
          '당사는 다음 중 어느 하나에 해당하는 경우를 제외하고, 고객으로부터 취득한 개인데이터를 제3자에게 제공하지 않습니다.',
        case1:
          '고객으로부터 제3자(상품 제공자, 해외 여행업자, 소셜미디어 사업자, 광고 배포 서비스 회사 등의 사업자를 포함합니다.)에 대한 개인데이터의 제공에 관하여, 본 개인정보 처리방침에 동의하는 방법 또는 그 밖의 방법으로 사전에 동의를 받은 경우',
        case2:
          '위 이용 목적의 달성에 필요한 범위 내에서 개인데이터의 취급을 외부에 위탁한 경우',
        case3: '법령에 근거하여 제공을 요구받은 경우',
        case4:
          '사람의 생명, 신체 또는 재산의 보호를 위하여 필요한 경우로서 고객의 동의를 받는 것이 곤란한 경우',
        case5:
          '공중위생의 향상 또는 아동의 건전한 육성 추진을 위하여 특별히 필요한 경우로서 고객의 동의를 받는 것이 곤란한 경우',
        case6:
          '국가 또는 지방공공단체 등이 법령에서 정하는 사무를 수행하는 데 협력할 필요가 있는 경우로서, 고객의 동의를 받음으로써 해당 사무의 수행에 지장을 미칠 우려가 있는 경우'
      },
      policy3: {
        title: '외국에 있는 제3자에 대한 개인데이터 제공에 대하여',
        description1:
          '전조에 정하는 경우로서, 당사는 본 서비스에서의 부정거래 탐지 및 방지를 목적으로 고객의 개인데이터를 외국에 소재하는 제3자에게 제공하는 경우가 있습니다.',
        description2:
          '당사는 개인정보보호법 및 그 밖의 관계 법령에 따라, 외국에 있는 제3자에 대한 개인데이터 제공에 관하여 필요한 정보를 고객에게 제공한 후 고객의 동의를 취득하거나, 그 밖의 적법한 방법에 근거하여 해당 제공을 실시합니다.',
        description3:
          '당사는 제공 대상의 소재 국가의 개인정보 보호 제도에 관한 정보, 해당 제3자가 취하는 개인정보 보호 조치 및 그 밖에 법령상 제공이 요구되는 정보에 대하여, 당사 웹사이트 게재 또는 그 밖에 당사가 적당하다고 인정하는 방법으로 공표 또는 제공합니다.',
        description4:
          '본 서비스에서 부정거래의 탐지 및 방지를 목적으로 고객으로부터 취득하여 외국에 소재하는 제3자에게 제공하는 데이터의 항목 등 상세 내용은 다음과 같습니다.',
        item1Label: '（１）제공하는 개인데이터의 항목',
        item1Content:
          '온라인 거래 정보(사용자 ID, 회원번호, 성명, 전자메일 주소, 전화번호, 주소 등), 디바이스 정보(OS 종류, 언어, IP 주소, 브라우저 종류, 위치 정보, 단말기 식별번호 등)',
        item2Label: '（２）제공의 수단 또는 방법',
        item2Content:
          '전자적 방법(온라인 거래 정보는 해시 처리하여 판독할 수 없는 상태로 송신합니다.)',
        item3Label: '（３）부정 탐지 서비스 사업자 및 소재하는 외국의 명칭 등',
        companyNameLabel: '사업자명 : ',
        companyName: 'Forter, Inc.',
        countryLabel: '소재 국가: ',
        country: 'United States',
        addressLabel: '주소: ',
        address: '575 5th Avenue, New York, United States (10017)',
        representativeLabel: '대표자: ',
        representative: 'Michael Reitblat',
        item4Label: '（４）외국에서의 개인정보 보호에 관한 제도에 관한 정보',
        item4Content: '다음 개인정보보호위원회 사이트에서 확인해 주십시오.',
        item5Label:
          '（５）부정 탐지 서비스 운영 사업자가 취하는 개인정보 보호 조치',
        item5Content:
          '아래 Forter 사 웹페이지(개인정보 처리방침 등)에서 확인해 주십시오.',
        description5:
          '고객이 회원 등록 또는 티켓 구매 시 본 개인정보 처리방침에 동의한 경우에는, 본 항에 정하는 외국에 있는 제3자에 대한 개인데이터 제공에 대해서도 함께 동의한 것으로 취급하는 경우가 있습니다.'
      },
      policy4: {
        title: '개인데이터 취급의 위탁에 대하여',
        description:
          '당사는 전항에 근거하여 당사의 이용 목적 달성에 필요한 범위 내에서 제3자에게 고객의 개인데이터 취급을 위탁하는 경우, 수탁자에 대하여 필요하고 적절한 감독을 실시합니다. 또한 수탁자가 재위탁을 하는 경우에는, 당사는 수탁자가 재수탁자에 대하여 필요하고 적절한 감독을 실시하고 있는지 여부를 직접 또는 간접적으로 감독합니다. 재수탁자가 다시 재위탁하는 경우에도 동일합니다.'
      },
      policy5: {
        title: '쿠키(Cookie) 정보 등의 취득에 대하여',
        cookie: {
          title: '쿠키(Cookie)',
          description1:
            '당사는 세션 쿠키 및 그 밖의 쿠키를 이용하는 경우가 있습니다. 쿠키란 고객(사용자)에 관한 정보를 포함하여 사용자의 하드 드라이브에 저장되는 데이터의 하나입니다. 당사에서는 쿠키를 개인을 특정하는 정보로 이용하지 않습니다. 또한 세션 쿠키는 브라우저를 닫으면 삭제됩니다.',
          description2:
            '쿠키는 고객에 대한 서비스 향상, 당사 사이트의 커스터마이즈·광고 효과의 측정 등의 목적으로 이용합니다.',
          description3:
            '또한 당사는 통계 처리 데이터로서 쿠키를 분석함으로써 고객의 관심이 높은 사항을 파악하여 이를 활용하고 있으며, 부정 접근 방지를 위해서도 이용하고 있습니다.',
          description4:
            '쿠키는 고객의 희망에 따라 무효화할 수 있으나, 그로 인하여 고객은 LINKTIVITY에서 예약을 할 수 없게 됩니다. 또한 당사는 부정 이용 방지 및 거래 리스크 평가를 목적으로 쿠키, 디바이스 식별자 및 그 밖에 이에 준하는 정보를 취득하여 부정 이용 방지 서비스 제공 사업자에게 제공하는 경우가 있습니다.'
        },
        logFile: {
          title: '로그 파일',
          description1:
            '당사에서는 특정 정보를 자동적으로 수집하여 로그 파일에 저장하고 있습니다. 이 특정 정보에는 IP(인터넷 프로토콜) 주소, 브라우저의 종류, ISP(인터넷 서비스 프로바이더), 참조/종료 페이지, 운영체제, 날짜/타임스탬프가 포함됩니다. 당사는 이러한 정보를 부정 접근을 감시할 목적으로 이용하고 있습니다. 또한 당사는 고객의 경향 분석, 사이트 관리, 사이트에서의 고객 동향 추적을 실시하고 있습니다.',
          description2:
            '다만 당사는 이러한 정보를 특정 개인을 식별할 수 없도록 하여 이용하고 있으며, 취득한 정보를 위 목적 이외의 목적으로 이용하지 않습니다. 당사는 부정 이용 방지 및 보안 향상을 위하여 IP 주소, 브라우저 정보, 단말기 식별 정보, 접속 로그 및 그 밖의 온라인 식별 정보를 취득하여 부정 이용 방지 서비스 제공 사업자에게 제공하는 경우가 있습니다.'
        },
        webBeacon: {
          title: '웹 비콘에 대하여',
          description:
            '당사에서는 웹 비콘을 접속 분석 및 어필리에이트 프로그램을 위하여 이용하고 있습니다. 당사는 웹 비콘을 위 목적 이외의 목적으로 이용하거나 특정 개인을 식별하기 위하여 이용하지 않습니다.'
        },
        statisticalAnalysis: {
          title: '통계적 분석에 대하여',
          description1:
            '당사에서는 어떤 사이트나 서비스의 인기가 높은지를 확인하기 위하여 제3자 접속 분석 도구를 이용하여, LINKTIVITY 사이트 내에서 고객이 접속한 페이지와 페이지 이력을 기록하고 있습니다.',
          description2:
            '당사는 이러한 데이터를 특정 분야에 관심을 보인 고객에게 LINKTIVITY 내에서 그 관심에 맞는 콘텐츠나 광고를 제공하기 위하여 사용하고 있습니다.',
          description3:
            '또한 개인을 특정하지 않는 통계 정보를 수집하는 경우도 있습니다. 나아가 제3자 접속 분석 도구상에서 당사가 수집한 쿠키 정보와 타사가 수집한 쿠키 정보를 상호 열람 가능하게 하는 경우도 있습니다.'
        }
      },
      policy6: {
        title: '익명가공정보의 취급에 대하여',
        creation: {
          title: '익명가공정보의 작성',
          description1:
            '당사는 익명가공정보를 작성하는 경우 다음과 같은 대응을 실시합니다. 익명가공정보란 법령에서 정하는 조치를 취하여 특정 개인을 식별할 수 없도록 개인정보를 가공하여 얻어지는 개인에 관한 정보로서, 해당 개인정보를 복원할 수 없도록 한 것을 말합니다.',
          description2:
            '① 법령에서 정하는 기준에 따라 적정하게 가공할 것 ② 법령에서 정하는 기준에 따라 삭제한 정보나 가공 방법에 관한 정보의 누출을 방지하기 위하여 안전관리조치를 취할 것 ③ 작성한 익명가공정보에 포함되는 정보의 항목을 공표할 것 ④ 작성에 사용된 개인정보에 관한 본인을 식별하기 위한 행위를 하지 않을 것'
        },
        provision: {
          title: '익명가공정보의 제공',
          description:
            '익명가공정보를 제3자에게 제공하는 경우에는, 제공하려는 익명가공정보에 포함되는 개인에 관한 정보의 항목과 제공 방법을 공표함과 동시에, 제공 대상이 되는 제3자에게 제공하는 정보가 익명가공정보임을 명시합니다.'
        },
        disclosure: {
          title: '익명가공정보에 관한 공표',
          creationSubtitle: '익명가공정보의 작성에 대하여',
          creationDescription:
            '당사가 보유하는 다음 고객의 개인정보에 대하여, 당사는 특정 개인을 식별하는 것 및 개인정보를 복원하는 것이 불가능하도록 적절한 조치를 취한 후 익명가공정보로서 계속적으로 작성합니다.',
          itemsTitle: '익명가공정보에 포함되는 개인에 관한 정보의 항목',
          itemsDescription:
            '플랫폼 서비스의 제공에 관하여 취득한 정보—구매일, 참가일, 바우처의 언어, 판매금액의 범위, 참가 인원수, 예약 상태(예약 확정 또는 취소 등), 서플라이어의 소재 지역 및 현(県) 정보, 여행사의 소재 국가',
          thirdPartyTitle: '익명가공정보의 제3자 제공에 대하여',
          thirdPartyDescription:
            '당사가 작성 또는 보유하는 익명가공정보에 대하여, 해당 정보가 익명가공정보임을 명시한 후 계속적으로 제3자에게 제공합니다.',
          provisionMethod:
            '비밀번호로 보호된 전자 파일을 전자적 통신 수단(이메일, 서버 업로드, API 연계 등) 또는 DVD 등의 물리적 매체로 송부'
        }
      },
      policy7: {
        title: '개인데이터의 안전관리조치에 대하여',
        description1:
          '개인데이터의 누출, 도용, 악용, 부정 접근, 위조 및 파괴 등을 방지하기 위하여 조직적·기술적·물리적 안전관리조치를 취하고 있습니다. 당사가 개인데이터를 저장하는 서버에 대한 접근은 ID/PW를 보유한 특정 종업원으로만 제한되어 있으며, 그중 일부 개인데이터의 관리에 대해서는 데이터 관리 등에 필요한 최소한의 종업원에게만 접근 권한을 부여하고 있습니다.',
        description2:
          '또한 신용카드 정보를 포함한 개인데이터에 대해서는 복수의 데이터 센터에 분산하여 보안이 확보된 환경에서 보관하고 있습니다. 그리고 당사는 예약 거래에 관한 모든 페이지에서 Secure Sockets Layer(SSL) 암호를 사용하고 있습니다. SSL 대응 브라우저의 사용을 통하여 인터넷상에서 송신하는 개인데이터와 신용카드 정보의 기밀성을 유지할 수 있습니다.',
        description3:
          '또한 고객의 개인데이터를 취급하는 당사의 종업원은 단말기를 떠날 때 비밀번호로 보호된 화면 보호기를 사용하고 있습니다.',
        description4:
          '나아가 당사는 부서에 따라서는 매월 1회, 전사적으로는 반년에 1회 이상의 빈도로 개인정보의 중요성 등에 관한 교육 연수를 실시하고 있습니다. 또한 교육에 관한 기록도 남기고 있습니다.'
      },
      policy8: {
        title: '고객의 개인데이터 취급에 관한 권리에 대하여',
        description:
          '2016년 4월 27일자 EU 일반 데이터 보호 규정(GDPR) 2016/679에 근거하여, 개인데이터의 처리에 관하여 고객에게는 다음의 권리가 있습니다.',
        right1: '접근권(열람권)',
        right2: '정정권',
        right3: '삭제권(잊힐 권리)과 처리를 제한할 권리',
        right4: '데이터 이동권(데이터 포터빌리티권)',
        right5: '이의를 제기할 권리',
        right6:
          '프로파일링을 포함한 자동 처리에 근거한 결정에 따르지 않을 권리.'
      },
      policy9: {
        title: '공개·정정·이용 정지 등의 청구 등에 대하여',
        description1:
          '당사는 고객으로부터의 보유 개인데이터의 이용 목적 통지 요구, 공개 청구, 정정·추가·삭제 청구, 이용 정지·소거 청구 또는 제3자 제공의 정지 청구(이하 총칭하여 「공개 등의 청구 등」이라 합니다.)에 대해서는 아래 12에 기재된 연락 창구에서 대응합니다.',
        description2:
          '또한 당사는 고객의 마이페이지에서 회원 정보의 변경 및 확인, 이메일 매거진의 발송 정지 등의 희망에 응하고 있습니다.'
      },
      policy10: {
        title: '외부 링크에 대하여',
        description:
          'LINKTIVITY 홈페이지에는 다른 사이트로의 링크가 포함되어 있습니다. 본 개인정보 처리방침은 LINKTIVITY 홈페이지에 의하여 수집되는 정보에만 적용되며, 그 밖의 웹사이트의 개인정보 처리방침 또는 콘텐츠에 대하여 당사는 책임을 지지 않습니다. 고객께서는 링크된 각 웹사이트에서 개인정보 처리방침을 읽고 고객의 개인정보 취급에 대하여 확인해 주시기를 부탁드립니다.'
      },
      policy11: {
        title: '개인정보 처리방침의 변경에 대하여',
        description:
          '당사는 개인정보 처리방침을 LINKTIVITY 홈페이지에 게재하여, 당사가 고객의 어떤 개인정보를 어떤 목적으로 취득하고 이용하는지를 고객이 항상 알 수 있는 상태로 하고 있습니다. 또한 개인정보 처리방침의 변경에 대해서도 LINKTIVITY 홈페이지에 게재하여 고객에게 공표하고 있습니다.'
      },
      policy12: {
        title: '연락처에 대하여',
        description1:
          '당사의 개인정보 처리방침, 당사의 개인정보 보호에 대한 노력, 고객의 개인정보 취득·이용 등에 관한 질문 또는 공개 등의 청구 등에 대해서는 아래 문의 양식을 이용해 주십시오. 담당자가 5영업일 이내에 답변드리겠습니다.',
        company: '링크티비티 주식회사(Linktivity Inc.)',
        address:
          '우편번호 100-0011 도쿄도 지요다구 우치사이와이초 2-1-6 히비야 파크 프론트 19F',
        dpoContact: '데이터 보호 책임자 연락처: dpo@linktivity.co.jp'
      },
      contentLabels: {
        acquisitionOfPersonalInfo: '취득하는 개인정보의 항목',
        specificPurpose: '구체적인 이용 목적',
        legalBasis: '법적 근거 : ',
        provisionMethod: '제공 방법'
      }
    },
    product: {
      plans: {
        title: '플랜 선택'
      },
      cancelPolicy: {
        title: '취소 정책'
      },
      recommendations: {
        title: '기타 추천'
      },
      panels: {
        selectDate: '날짜 선택',
        selectPlan: '플랜 선택',
        selectPeople: '인원 선택',
        options: '옵션',
        profile: '프로필'
      },
      auth: {
        loginOrRegister: '로그인 / 회원가입'
      }
    },
    book: {
      title: '예약 확인',
      bookingNotice: '예약 전 확인',
      paymentConfirmation: '결제 전 확인',
      tip: '주문을 확정하려면 15분 이내에 절차를 완료해 주세요.',
      sessionInfo: '예약 정보'
    },
    bookConfirm: {
      productInfo: '상품 정보',
      sessionConfirmed: '확인됨',
      sessionUnconfirmed: '미확인',
      paymentInfo: '결제 정보',
      paymentConfirmation: {
        warningTitle: '취소 정책을 확인하세요:',
        warningText: '구매 후 반환할 수 없습니다.',
        agreementText: '위의 내용을 확인하였고, 동의합니다.'
      },
      prePaymentConfirmation: {
        title: '결제 전 확인 사항',
        checkInput: '입력 내용이 올바른지 확인해 주세요.',
        emailNotice:
          '주의: 스팸 메일 차단을 위해 도메인 지정 수신 설정을 하신 경우, 예약 전 "@linktivity.co.jp" 도메인을 등록해 주세요.',
        agreementText: '위 사항을 확인하고 동의합니다.'
      },
      paymentAmount: {
        total: '결제 금액 (세금 포함)',
        details: '상세',
        note: '일본 엔화 이외의 통화로 표시되는 금액은 현재 환율을 기준으로 한 추정값이며, 실제 청구 금액과 다를 수 있습니다. 참고용으로 확인해 주시기 바랍니다.'
      },
      confirmPaymentDialogTitle: '결제 확인',
      participantInfo: {
        title: '참가자 정보',
        dialogTitle: '참가자 정보 변경',
        change: '변경',
        password: '비밀번호',
        validation: {
          passwordRequired: '비밀번호를 입력해 주세요'
        }
      },
      couponApplied: '쿠폰이 성공적으로 적용되었습니다',
      couponFailed: '쿠폰 적용에 실패했습니다',
      couponRemoved: '쿠폰이 성공적으로 제거되었습니다',
      couponRemoveFailed: '쿠폰 제거에 실패했습니다',
      actionButtons: {
        back: '이전',
        toPayment: '결제로'
      }
    },
    voucher: {
      pdf: '출력용 PDF',
      html: '바우처'
    },
    bookingDetail: {
      title: '예약 상세',
      detailInfo: '예약 상세',
      startDate: '참가 일시',
      validityPeriod: '유효 기간',
      voucherInfo: '바우처',
      digitalTicket: '전자 티켓',
      invoice: '영수증·송장',
      invoiceSend: '발행',
      invoiceSent: '송장 발행 완료',
      redemption: 'E-티켓 사용',
      meetingPoint: '입장 위치 안내',
      beforeTrip: '이용 전 확인 사항',
      bookingAction: '예약 관리',
      cancelBooking: '예약 취소',
      cancelConfirmPolicy: '취소 정책을 확인해 주세요:',
      customerName: '예약자명',
      actualPayment: '결제 금액',
      refundAmount: '환불 금액',
      orderId: '예약 ID',
      orderCompletionTime: '예약 시간',
      digitalTicketValidPeriod: 'QR 코드는 이용 당일에만 유효합니다',
      digitalTicketWaiting: '*주문 확인 후 전자 티켓이 여기에 표시됩니다',
      sending: '전송 중...',
      sendToEmail: '이메일로 전송',
      cancelConfirm: '예약을 취소하시겠습니까?',
      cancelFee: '취소 수수료',
      cancelRemarkSelect: '취소 사유를 선택해 주세요',
      inclusion: '포함된 물품',
      checklist: '주의사항',
      restrictions: '참가 제한',
      requirements: '참가 전 및 참가 중 필요 사항',
      attireItems: '참가 시 필요 의복 및 소지품',
      otherInfo: '비고·기타',
      attachmentType: {
        ATTACHMENT_TYPE_PDF: 'PDF',
        ATTACHMENT_TYPE_IMAGE: 'Image'
      }
    },
    cancelReason: {
      CANCEL_REASON_OTHER: '기타',
      CANCEL_REASON_MODIFY_BOOKING: '예약 내용을 변경하고 싶어요',
      CANCEL_REASON_BOOKED_BY_MISTAKE: '잘못 예약함',
      CANCEL_REASON_DUPLICATE_BOOKING: '중복 예약이라서',
      CANCEL_REASON_HEALTH_CONDITION: '질병',
      CANCEL_REASON_TRANSPORTATION_ISSUE: '항공편 취소·지연·변경',
      CANCEL_REASON_SCHEDULE_CONFLICT: '일정 충돌',
      CANCEL_REASON_CHANGE_TO_OTHER_PRODUCT: '다른 상품으로 변경'
    },
    common: {
      withDashSeparated: '{{val1}} - {{val2}}'
    },
    home: {
      title: 'SHIBUYA SKY',
      header: {
        alt: 'SHIBUYA SKY'
      },
      search: {
        placeholder: '상품 검색'
      },
      ticketList: {
        title: '티켓 목록'
      },
      enjoyPack: {
        title: '엔조이 팩'
      }
    },
    faq: {
      tips: `본 FAQ에 안내된 내용(온라인 구매, 취소, 영수증 발급 등)에 관한 문의는 LINKTIVITY(링크티비티) 고객지원팀으로 문의해 주세요.
SHIBUYA SKY의 시설 및 서비스 등에 관한 문의는 SHIBUYA SKY 공식 사이트의 문의 페이지를 통해 문의해 주세요.
https://www.shibuya-scramble-square.com/sky/contact/

LINKTIVITY(링크티비티) 고객지원팀
이메일: <a href="mailto:helpcenter@linktivity.co.jp" rel="noreferrer">helpcenter@linktivity.co.jp</a>
온라인 구매 관련 문의 전화: <a href="tel:+81368217193">03-6821-7193</a>
※전화 문의 시 먼저 자동 음성 안내가 제공되며, 이후 문의 내용에 따라 상담원에게 연결됩니다.
※전화 문의 시 통화료가 발생합니다.
상담원 응대 가능 시간: 10:00~19:00`
    }
  }
};
